import { render, staticRenderFns } from "./StrdPL_List.vue?vue&type=template&id=2297e3b8"
import script from "./StrdPL_List.vue?vue&type=script&lang=js"
export * from "./StrdPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports